import React from 'react';
import '../assets/styles/MunicipioLayout.scss';
import Turismo from '../components/comuna/Turismo';

const TurismoContainer = () => (
  <div className='MainMunicipio'>
    <Turismo />
  </div>
);
export default TurismoContainer;
